import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";
import { useNavigate } from "react-router-dom";

export const DeleteAlertDialog = () => {
  const navigate = useNavigate();

  const {
    deleteAlertDialogOpen,
    setDeleteAlertDialogOpen,
    handleDeleteAlerts,
  } = useEditCameraStore();

  return (
    <Dialog open={deleteAlertDialogOpen}>
      <DialogTitle id="alert-dialog-title">
        {" Are you sure you want to delete this Alert?"}
      </DialogTitle>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setDeleteAlertDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            handleDeleteAlerts(navigate);
            setDeleteAlertDialogOpen(false);
          }}
          text="Delete Alert"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
